import React, { SVGProps } from 'react';
import { ReactComponent as INDIA } from './in.svg'

const SvgCustomFrance = (props: SVGProps<SVGSVGElement>) => (
	<INDIA></INDIA>
);

export default SvgCustomFrance;
